import { Injectable, inject } from '@angular/core';

import { FeatureToggleService } from './feature-toggle.service';
import { SpaRoute } from './models';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionHelperService {
  private readonly featureToggleService = inject(FeatureToggleService);
  private readonly tokenService = inject(TokenService);

  public filterPermittedRoutes(routes: SpaRoute[], unlinkedRoutes: string[] = ['**']) {
    return routes
      .filter((r) => !r.path || !unlinkedRoutes.includes(r.path))
      .filter((r) => !r.data?.permission || this.tokenService.hasPermission(r.data?.permission))
      .filter((r) => !r.data?.features || this.featureToggleService.hasFeature(r.data.features));
  }
}
